import { useState } from "react";

const FILE_NAME = "video.mp4";
const REVOKE_DELAY_MS = 1000;

export const useVideoDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadVideo = async (videoUrl) => {
    if (!videoUrl) return;
    setIsDownloading(true);
    try {
      const blob = await (await fetch(videoUrl)).blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = FILE_NAME;
      a.click();

      setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
    } catch (err) {
      console.error("Download error:", err);
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, downloadVideo };
};
